// extracted by mini-css-extract-plugin
export default {"textArea":"styles_textArea__DYd-U","disabled":"styles_disabled__42NYr"};